import crudHandlers from './_crud'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'LOAD_INCIDENT_SUBCATEGORY':
			return {
				...state,
				entities: action.payload,
			}
		default:
			state = crudHandlers(state, action, 'incident_subcategory')

			return state
	}
}
